import React, { useEffect, useState } from "react";
import { fetchClientSubServicesApi, sendMonthlyDataApi } from "../Data/Api";
import { toast, ToastContainer } from "react-toastify";
import GetSecure from "../Request/GetSecure";
import Loader from "../NewComponents/Loading-States/Loader";
import axios from "axios";
import { fetchClientServices } from "../Data/Api";
import { useLocation, useNavigate } from "react-router-dom";
import TitleHeader from "../NewComponents/Header/TitleHeader";
import classes from "./DailyRevenuePage.module.css";
import NewSidebarAdmin from "../NewComponents/Sidebar/NewSidebarAdmin";
import NewHeader from "../NewComponents/Header/NewHeader";
import { Dropdown } from "primereact/dropdown";
import NewHeaderAdmin from "../NewComponents/Header/NewHeaderAdmin";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ExportMonthlyRevenueToExcel from "../NewComponents/Excel-Sheet-Generation/ExportMonthlyRevenueToExcel";
import { TabView, TabPanel } from "primereact/tabview";
import LineGraph from "../NewComponents/Graphs/LineGraph";
import BarGraph from "../NewComponents/Graphs/BarGraph";
import VerticalBarGraph from "../NewComponents/Graphs/VerticalBarGraph";
// import ExportToExcel from "../Components/ExportToExcel";


// Monthly Revenue Admin Page is the page that takes the client + service + subservice + month interval to get the revenue.
const MonthlyRevenueAdminPage = () => {
  const [clients, setClients] = useState([]);
  const [client, setClient] = useState("");
  const [services, setServices] = useState([]);
  const [service, setService] = useState();

  const [subServices, setSubServices] = useState([]);
  const [subService, setSubService] = useState("");

  const [clientForDropdown, setClientForDropdown] = useState("");
  const navigate = useNavigate();

  const [sidebarHide, setSidebarHide] = useState(() =>
    localStorage.getItem("sidebar")
      ? JSON.parse(localStorage.getItem("sidebar"))
      : false
  );
  const sidebarHandler = () => {
    localStorage.setItem("sidebar", JSON.stringify(!sidebarHide));
    setSidebarHide(JSON.parse(localStorage.getItem("sidebar")));
  };

  //Hook to store services
  const [responseService, setResponseService] = useState("");

  const location = useLocation();

  useEffect(() => {
    const state = location?.state;

    if (state?.main_service !== undefined) {
      let clientId = state?.client;
      let main_service = state?.main_service;
      let sub_service = state?.sub_service;

      let all_clients = JSON.parse(localStorage.getItem("clients"));
      let filteredClient = all_clients?.filter((data) => data?.id == clientId);

      setClients(all_clients);
      setClient(filteredClient[0]);
      setSubService(sub_service);
      gettingClientServices({
        state: true,
        clientId: filteredClient[0]?.id,
        main_service: main_service,
        sub_service: sub_service,
      });
    } else {
      let all_clients = JSON.parse(localStorage.getItem("clients"));
      setClients(all_clients);
      setClient(all_clients[0]);
      gettingClientServices({ state: false, clientId: all_clients[0]?.id });
    }
  }, [location]);

  async function gettingClientServices(data) {
    if (data?.state === true) {
      try {
        setLoader("block");
        //fetch Services of that client and store in localStorage;
        // gettingServices() function call;
        let token = localStorage.getItem("userToken");
        let headers = { Authorization: "Bearer " + token };
        const res = await axios.post(
          `${fetchClientServices}?clientId=${data?.clientId}`,
          data,
          {
            headers: headers,
          }
        );
        setLoader("none");
        setServices(res?.data?.data);
        let filteredService = res?.data?.data?.filter(
          (dataItem) =>
            dataItem?.serviceName?.toLowerCase() ==
            data?.main_service?.toLowerCase()
        );

        setService(filteredService[0]);

        fetchSubServicesOfMainService({
          state: true,
          main_service: filteredService[0],
          sub_service: data?.sub_service,
        });
      } catch (error) {
        setLoader("none");
        if (error?.response?.status == 403) {
          toast.error(
            error?.response?.data?.message ||
              error?.data?.message ||
              error?.message ||
              error
          );
          setTimeout(() => {
            window.location.href = "/";
          }, 1500);
        } else {
          toast.error(
            error?.response?.data?.message ||
              error?.data?.message ||
              error?.message ||
              error
          );
        }
      }
    } else {
      try {
        setLoader("block");
        //fetch Services of that client and store in localStorage;
        // gettingServices() function call;
        let token = localStorage.getItem("userToken");
        let headers = { Authorization: "Bearer " + token };
        const res = await axios.post(
          `${fetchClientServices}?clientId=${data?.clientId}`,
          data,
          {
            headers: headers,
          }
        );
        setServices(res?.data?.data);
        setService(res?.data?.data[0]);
        console.log(res?.data?.data[0], "ddkjdlka");

        setLoader("none");

        fetchSubServicesOfMainService({
          state: false,
          main_service: res?.data?.data[0],
          sub_service: null,
        });
      } catch (error) {
        setLoader("none");
        if (error?.response?.status == 403) {
          toast.error(
            error?.response?.data?.message ||
              error?.data?.message ||
              error?.message ||
              error
          );
          setTimeout(() => {
            window.location.href = "/";
          }, 1500);
        } else {
          toast.error(
            error?.response?.data?.message ||
              error?.data?.message ||
              error?.message ||
              error
          );
        }
      }
    }
  }

  const fetchSubServicesOfMainService = async (check) => {
    if (check?.state === true) {
      try {
        setLoader("block");
        let token = localStorage.getItem("userToken");
        let headers = { Authorization: "Bearer " + token };
        const response = await axios.post(
          `${fetchClientSubServicesApi}?mainServiceId=${check?.main_service?.id}`,
          {},
          {
            headers,
          }
        );
        let filteredSubService = response?.data?.data?.dataArray?.filter(
          (data) =>
            data?.subServiceName?.toLowerCase() ===
            check?.sub_service?.toLowerCase()
        );
        setSubService(filteredSubService[0]);
        setSubServices(response?.data?.data?.dataArray);
        getDataFromBackend(
          check?.main_service?.serviceName,
          filteredSubService[0]?.subServiceName
        );
        setLoader("none");
      } catch (error) {
        setLoader("none");

        if (error?.response?.status == 403) {
          toast.error(
            error?.response?.data?.message ||
              error?.data?.message ||
              error?.message ||
              error
          );
          setTimeout(() => {
            window.location.href = "/";
          }, 1500);
        } else {
          toast.error(
            error?.response?.data?.message ||
              error?.data?.message ||
              error?.message ||
              error
          );
        }
      }
    } else {
      try {
        setLoader("block");

        let token = localStorage.getItem("userToken");
        let headers = { Authorization: "Bearer " + token };
        const response = await axios.post(
          `${fetchClientSubServicesApi}?mainServiceId=${check?.main_service?.id}`,
          {},
          {
            headers,
          }
        );
        console.log(response?.data?.data?.dataArray, "r");
        setSubServices(response?.data?.data?.dataArray);
        setSubService(response?.data?.data?.dataArray[0]);

        setLoader("none");

        getDataFromBackend(
          check?.main_service?.serviceName,
          response?.data?.data?.dataArray[0]?.subServiceName
        );
      } catch (error) {
        setLoader("none");

        if (error?.response?.status == 403) {
          toast.error(
            error?.response?.data?.message ||
              error?.data?.message ||
              error?.message ||
              error
          );
          setTimeout(() => {
            window.location.href = "/";
          }, 1500);
        } else {
          toast.error(
            error?.response?.data?.message ||
              error?.data?.message ||
              error?.message ||
              error
          );
        }
      }
    }
  };

  //Hook to store dates
  const [interval, setInterval] = useState("6");

  //Method to get data from Backend
  const getDataFromBackend = (serviceName, subServiceName) => {
    setLoader("block");
    let promise = GetSecure(
      `${sendMonthlyDataApi}?interval=${interval}&service=${serviceName}&subService=${subServiceName}`
    );
    promise.then((e) => {
      handleDataResponse(e);
    });
  };

  //Hook to store data
  const [data, setData] = useState([]);

  //Hook to store biggest value
  const [biggest, setBiggest] = useState(0);
  const [biggestRenewal, setBiggestRenewal] = useState(0);
  const [biggestSubscription, setBiggestSubscription] = useState(0);

  //Method to handle response
  const handleDataResponse = (e) => {
    if (e.response === "error") {
      setLoader("none");
      if (e?.error?.response?.status == 403) {
        toast.error(e.error?.response?.data?.message || e.error?.message);
        setTimeout(() => {
          window.location.href = "/";
        }, 1500);
      } else {
        toast.error(e.error?.response?.data?.message || e.error?.message);
      }
    } else {
      setLoader("none");
      const dataDateManupulate = e.data.map((dataItem) => {
        return {
          id: `${dataItem.MONTH}-${dataItem.YEAR}`,
          misDate: `${dataItem.MONTH}-${dataItem.YEAR}`,
          renewalsRevenue: dataItem.renewalsRevenue,
          subscriptionRevenue: dataItem.subscriptionRevenue,
          totalRevenue: dataItem.totalRevenue,
        };
      });
      setData(dataDateManupulate.reverse());
      setResponseService(e.serviceName);
      const biggestValue = Math.max.apply(
        Math,
        e.data.map(function (dataItem) {
          return dataItem.totalRevenue;
        })
      );
      setBiggest(biggestValue);
      const biggestValueRenewal = Math.max.apply(
        Math,
        e.data.map(function (dataItem) {
          return dataItem.renewalsRevenue;
        })
      );
      setBiggestRenewal(biggestValueRenewal);
      const biggestValueSubscription = Math.max.apply(
        Math,
        e.data.map(function (dataItem) {
          return dataItem.subscriptionRevenue;
        })
      );
      setBiggestSubscription(biggestValueSubscription);
    }
  };

  //Hook to store loader div state
  const [loader, setLoader] = useState("block");

  //Method to handle service choose
  const handleChooseService = (data) => {
    setService(data);
    fetchSubServicesOfMainService({
      state: false,
      main_service: data,
      sub_service: null,
    });
  };

  const handleClientChange = (value) => {
    console.log(value, "value");

    let all_clients = JSON.parse(localStorage.getItem("clients"));
    let filteredClient = all_clients?.filter((data) => data?.id == value?.id);

    setClients(all_clients);
    setClient(filteredClient[0]);
    gettingClientServices({
      state: false,
      clientId: filteredClient[0]?.id,
      main_service: service,
      sub_service: null,
    });
  };

  const handleChooseSubService = (data) => {
    setSubService(data);
    getDataFromBackend(service?.serviceName, subService?.subServiceName);
  };

  const dataLength = data.length;
  let width = 3000;
  if (dataLength > 10) {
    width = 1000;
  }
  if (dataLength > 0 && dataLength <= 10) {
    width = 700;
  }

  const totalRenewalRevenue = data.reduce(
    (total, dataItem) => total + dataItem.renewalsRevenue,
    0
  );
  const totalSubscriptionRevenue = data.reduce(
    (total, dataItem) => total + dataItem.subscriptionRevenue,
    0
  );
  const totalRevenue = data.reduce(
    (total, dataItem) => total + dataItem.totalRevenue,
    0
  );

  const totals = {
    id: totalRevenue,
    misDate: "Totals",
    renewalsRevenue: totalRenewalRevenue,
    subscriptionRevenue: totalSubscriptionRevenue,
    totalRevenue: totalRevenue,
  };

  useEffect(() => {
    if (service?.serviceName && subService?.subServiceName) {
      getDataFromBackend(service?.serviceName, subService?.subServiceName);
    }
  }, [interval]);

  const header = <ExportMonthlyRevenueToExcel data={[...data, totals]} />;

  return (
    <>
      <Loader value={loader} />
      <ToastContainer />
      <div className={`${classes.main} ${sidebarHide && classes.short}`}>
        <div className={`${classes.sidebar} ${sidebarHide && classes.short}`}>
          <div
            className={`${classes.sidebar_header} ${
              sidebarHide && classes.short
            }`}
          >
            <img
              src="/assets/images/logo1.png"
              alt="Revenue portal"
              className={classes.sidebar_logo}
            />
            <h3 className={classes.dashboard_text}>Dashboard</h3>
          </div>
          <div className={classes.sidebar_icon}>
            <div className={classes.circle} onClick={sidebarHandler}>
              {sidebarHide ? (
                <i
                  className={`fa-solid fa-arrow-right ${classes.arrow_icon}`}
                ></i>
              ) : (
                <i
                  className={`fa-solid fa-arrow-left ${classes.arrow_icon}`}
                ></i>
              )}
            </div>
          </div>
          <NewSidebarAdmin highlight={3} sidebarHide={sidebarHide} />
        </div>
        <div className={classes.container}>
          <NewHeaderAdmin service={responseService} highlight={3} />
          <div className={classes.sub_container}>
            <form className={classes.form}>
              <div className={classes.client}>
                <Dropdown
                  value={client}
                  onChange={(e) => handleClientChange(e.value)}
                  options={clients?.map((client) => ({
                    label: client?.clientName,
                    value: client,
                  }))}
                  placeholder="Select a client"
                  style={{ width: "100%" }}
                />
              </div>

              <div className={classes.service}>
                <Dropdown
                  value={service}
                  onChange={(e) => handleChooseService(e.value)}
                  options={services?.map((serviceItem) => ({
                    label: serviceItem?.serviceName,
                    value: serviceItem,
                  }))}
                  placeholder="Select a service"
                  style={{ width: "100%" }}
                />
              </div>

              <div className={classes.service}>
                <Dropdown
                  value={subService}
                  onChange={(e) => handleChooseSubService(e.value)}
                  options={subServices?.map((serviceItem) => ({
                    label: serviceItem?.subServiceName,
                    value: serviceItem,
                  }))}
                  placeholder="Select a sub service"
                  style={{ width: "100%" }}
                />
              </div>

              <div className={classes.start_date}>
                <Dropdown
                  id="interval"
                  value={interval}
                  options={[
                    { label: "1", value: "1" },
                    { label: "2", value: "2" },
                    { label: "3", value: "3" },
                    { label: "4", value: "4" },
                    { label: "5", value: "5" },
                    { label: "6", value: "6" },
                    { label: "7", value: "7" },
                    { label: "8", value: "8" },
                    { label: "9", value: "9" },
                    { label: "10", value: "10" },
                    { label: "11", value: "11" },
                    { label: "12", value: "12" },
                  ]}
                  onChange={(e) => setInterval(e.value)}
                  placeholder="Select Month"
                  style={{ width: "100%" }}
                />
              </div>
            </form>

            <TitleHeader title="Monthly Revenue" icon="" />

            <TabView style={{ width: "100%" }} scrollable>
              <TabPanel header="Bar Chart">
                <BarGraph data={data} />
              </TabPanel>
              <TabPanel header="Line Chart">
                <LineGraph data={data} />
              </TabPanel>
              <TabPanel header="Vertical Bar Chart">
                <VerticalBarGraph data={data} />
              </TabPanel>
            </TabView>

            <div className={classes.table_container}>
              <DataTable
                value={[...data, totals]}
                emptyMessage="No data found"
                showGridlines
                responsive
                scrollable
                scrollHeight="500px"
                rows={40}
                paginator
                header={header}
              >
                <Column field="misDate" header="Date" />
                <Column
                  field="renewalsRevenue"
                  header="Renewals Revenue"
                  body={(rowData) =>
                    rowData?.renewalsRevenue
                      ? parseInt(rowData?.renewalsRevenue, 0)
                      : 0
                  }
                />
                <Column
                  field="subscriptionRevenue"
                  header="Subscription Revenue"
                  body={(rowData) =>
                    rowData?.subscriptionRevenue
                      ? parseInt(rowData?.subscriptionRevenue, 0)
                      : 0
                  }
                />
                <Column
                  field="totalRevenue"
                  header="Total Revenue"
                  body={(rowData) =>
                    rowData?.totalRevenue
                      ? parseInt(rowData?.totalRevenue, 0)
                      : 0
                  }
                />
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MonthlyRevenueAdminPage;
